import { Component, OnInit, Renderer2 } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { AuthenticationResult } from '../models/authentication.model';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
@Component({
  selector: 'app-auth-validate-details',
  templateUrl: './auth-validate-details.component.html',
  styleUrls: ['./auth-validate-details.component.css']
})
export class AuthValidateDetailsComponent extends AuthBaseComponent implements OnInit {
  public data: any = {};
  public loginOriginAction: string = "";

  constructor(private renderer: Renderer2, protected modalService: ModalService, protected authService: AuthUserService) {
    super(modalService, authService);
  }

  ngOnInit(): void {
    const element = this.renderer.selectRootElement('#uid');
    setTimeout(() => element.focus(), 0);
    this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2102' })
      .subscribe(res => console.log("sent elasticLog code:2102 - open window", res), error => console.log("sent elasticLog - open window error!", error));
    sessionStorage.setItem("currentWindow", "בדיקת פרטים אישיים");
    sessionStorage.setItem("elasticCode", "2186");
    this.data = this.modalService.data;
    this.isShowContactLink = this.shouldContactLink('authValidateDetails');
    this.loginOriginAction = sessionStorage.getItem("loginOriginAction");
  }

  submit(form): void {
    const element = this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    if (element) {
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
    if (form.valid) {
      this.pending = true;
      this.serverError = null;
      //console.log("sent parametes", { UserId: form.value.uid, FullPhone: form.value.phone });
      this.authUserService.sendAuthData("ValidateDetails", { UserId: form.value.uid, FullPhone: form.value.phone })
        .subscribe((res: AuthenticationResult) => {
          this.modalService.close(res.Details);
        }, () => this.pending = false,
          () => this.pending = false
        )
    }
    this.buildFormAccessibility();
  }
}
